<template>
   <div class="heading text-center">
       <div class="vld-parent">
            <loading :active.sync="isLoading" loader= 'bars' 
            :can-cancel="true" 
            :on-cancel="onCancel"
            :is-full-page="fullPage"></loading>
       </div>
    <img class="dividerline" src="../assets/img/sep.png" alt="" />
    <h2>Our Objective</h2>
    <img class="dividerline" src="../assets/img/sep.png" alt="" />
    <h3>
        MISSION STATEMENT:
    </h3>
    <ul style="text-align:left" v-for="(data, i) in missionstatement" :key="i+50">
        <li v-html="data"></li>
    </ul>
    <!-- <h3>
        AIMS:
    </h3>
    <ul style="text-align:left" v-for="(data, i) in aims" :key="i+100">
        <li v-html="data"></li>
    </ul> -->
    <h3>
        OBJECTIVES:
    </h3>
    <ul style="text-align:left" v-for="(data, i) in objectives" :key="i">
        <li v-html="data"></li>
    </ul>
</div>

</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from 'axios';
  export default {
    name: 'Objectives',
    components: {
    Loading
   },
    data () {
      return {
        msg: 'Objectives',
        isLoading: false,
        fullPage: true,
        info: null,
        missionstatement: null,
        //aims: null,
        objectives: null
    }
  },
  methods: {
    onCancel() {
              console.log('User cancelled the loader.')
            }
  },
  mounted () {
    this.isLoading = true;
    axios
      .get(process.env.NODE_API + '/objectives')
      .then(response => {
        this.info = response.data
        this.missionstatement=this.info[0].missionstatement
        //this.aims=this.info[0].aims
        this.objectives=this.info[0].objectives
        
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      })
      .finally(() => this.isLoading = false)
  }
}

</script>

<style>
  
</style>



// WEBPACK FOOTER //
// src/components/Objectives.vue